import { dataIsValid } from 'shared/utils';

import sentenceCapitalize from 'shared/utils/formatting/sentenceCapitalize';

function formatHomeAddress(addressLine1, city, state, zipcode) {
	const checkAddressFields = [addressLine1, city, state, zipcode];

	if (checkAddressFields.some((field) => !dataIsValid(field)))
		return 'Data Not Found';

	const formattedAddressLine1 = sentenceCapitalize(addressLine1);
	const formattedCity = sentenceCapitalize(city);
	const formattedState = state ? state.toUpperCase() : state;

	const formattedZipcode = zipcode;

	const formattedAddress = `${formattedAddressLine1}, ${formattedCity}, ${formattedState}, ${formattedZipcode}`;

	return formattedAddress;
}

export default formatHomeAddress;
